import { render, staticRenderFns } from "./ViewLayoutDialog.vue?vue&type=template&id=33408202"
import script from "./ViewLayoutDialog.vue?vue&type=script&lang=js"
export * from "./ViewLayoutDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports